import axios from "@/api/axiosInstance";
import { FetchMonthlyReportRequest, FetchMonthlyReportResponse } from "./types";

/**
 * Runs the combined monthly scoreboard report for a given month + year.
 * Backend endpoint: GET /api/private/scoreboard/monthly-report
 */
export const fetchMonthlyReport = async (
  request: FetchMonthlyReportRequest,
): Promise<FetchMonthlyReportResponse> => {
  const response = await axios.get<FetchMonthlyReportResponse>(
    "/api/private/scoreboard/monthly-report",
    { params: { year: request.year, month: request.month } },
  );
  return response.data;
};
